import { memo } from 'react';
import type { Connection } from '@/model/types';
import type { NodeBounds } from '@/layout/types';
import { cubicBezierPath } from '@/utils/geometry';

interface Props {
  connection: Connection;
  nodeBounds: Map<string, NodeBounds>;
}

const CROSS_LINK_COLOR = '#818cf8';

export const CrossLinkRenderer = memo(function CrossLinkRenderer({
  connection,
  nodeBounds,
}: Props) {
  const sourceBounds = nodeBounds.get(connection.sourceNodeId);
  const targetBounds = nodeBounds.get(connection.targetNodeId);

  if (!sourceBounds || !targetBounds) return null;

  const from = { x: sourceBounds.centerX, y: sourceBounds.centerY };
  const to = { x: targetBounds.centerX, y: targetBounds.centerY };

  const pathD = cubicBezierPath(from, to, 0.4);

  const midX = (from.x + to.x) / 2;
  const midY = (from.y + to.y) / 2;

  return (
    <g>
      <path
        d={pathD}
        fill="none"
        stroke={CROSS_LINK_COLOR}
        strokeWidth={1.5}
        strokeDasharray="6 4"
        strokeLinecap="round"
      />
      {connection.label && (
        <text
          x={midX}
          y={midY - 6}
          textAnchor="middle"
          fill={CROSS_LINK_COLOR}
          fontSize={11}
          style={{ pointerEvents: 'none', userSelect: 'none' }}
        >
          {connection.label}
        </text>
      )}
    </g>
  );
});
